/**
 * Utilidades para manejar roles de usuario
 */

/**
 * Obtiene el rol del usuario desde localStorage o del objeto user
 * @returns {string|null} El rol del usuario o null si no está disponible
 */
export const getUserRole = () => {
  // Intentar obtener el rol directamente de localStorage
  const roleFromStorage = localStorage.getItem('userRole');
  if (roleFromStorage) {
    return roleFromStorage;
  }

  // Intentar obtener del objeto user guardado
  const userFromStorage = localStorage.getItem('user');
  if (userFromStorage) {
    try {
      const user = JSON.parse(userFromStorage);
      // Buscar el rol en diferentes posibles ubicaciones
      return user.role || user.roles || user.authority || user.authorities || null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  }

  return null;
};

/**
 * Verifica si el usuario es un operario
 * @returns {boolean} true si el usuario es operario
 */
export const isOperario = () => {
  const role = getUserRole();
  if (!role) return false;
  
  // Normalizar el rol para comparación
  const normalizedRole = role.toString().toUpperCase();
  
  // Verificar diferentes formatos posibles
  return (
    normalizedRole === 'OPERARIO' ||
    normalizedRole === 'ROLE_OPERARIO' ||
    normalizedRole.includes('OPERARIO')
  );
};

/**
 * Verifica si el usuario tiene acceso a Twilio
 * @returns {boolean} true si el usuario puede usar Twilio
 */
export const hasTwilioAccess = () => {
  return !isOperario();
};

/**
 * Verifica si el usuario es admin o manager
 * @returns {boolean} true si el usuario es admin o manager
 */
export const isAdminOrManager = () => {
  const role = getUserRole();
  if (!role) return false;
  
  const normalizedRole = role.toString().toUpperCase();
  
  return (
    normalizedRole === 'ADMIN' ||
    normalizedRole === 'ROLE_ADMIN' ||
    normalizedRole === 'MANAGER' ||
    normalizedRole === 'ROLE_MANAGER' ||
    normalizedRole.includes('ADMIN') ||
    normalizedRole.includes('MANAGER')
  );
};
